module.exports = __webpack_public_path__ + "static/img/u177.cfdb7a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u177.png
// module id = SSVR
// module chunks = 0